module.exports = __webpack_public_path__ + "img/szxxzyjs.cd9c7bdc.png";